import { render } from "./SubActivityForms.vue?vue&type=template&id=30f2d727&scoped=true"
import script from "./SubActivityForms.js?vue&type=script&lang=js"
export * from "./SubActivityForms.js?vue&type=script&lang=js"

import "./SubActivityForms.vue?vue&type=style&index=0&id=30f2d727&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f2d727"]])

export default __exports__